import type { oz } from '@weft/utils';
import { ProductsPageSchema } from '../../../shared-schemas';

export const GetProductsPageDataResponseSchema = ProductsPageSchema.openapi('GetProductsPageResponse');

export type GetProductsPageDataResponse = oz.infer<typeof GetProductsPageDataResponseSchema>;